/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedTitle_buyPage = {
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly " $refType": "BuySharedTitle_buyPage";
};
export type BuySharedTitle_buyPage$data = BuySharedTitle_buyPage;
export type BuySharedTitle_buyPage$key = {
    readonly " $data"?: BuySharedTitle_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedTitle_buyPage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedTitle_buyPage",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "header",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'ac579f5f8cd87e18c4f3dceb5683cbb5';
export default node;
